//=============================================================================
//                       <--- Developed By Icon Team --->
//=============================================================================

// npm packages
import React, { useState, useCallback, useContext, useEffect } from "react";
import * as moment from "moment";
import { toast } from "react-toastify";
import { useHistory } from "react-router";
import access from "config/access";
import { CSVLink } from 'react-csv';


// custom pages
import { toastCss } from "assets/styleJS/global";
import { styles } from "./styles";
import { ImportDataHeader } from "./Headers/headers";
import ImportDataAPI from "apis/importData/importData";
import NoData from "components/Table/NoData";
import Loader from "components/Loader/Loader";
import Context from "context/context";

// material-ui
import { withStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import Grid from "@material-ui/core/Grid";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";

import { useTranslation } from 'react-i18next';
import { dateFormat } from "helpers/dataFormat"
const Papa = require("papaparse/papaparse.min.js");

const GlobalCss = withStyles({
  "@global": {
    " .MuiDialog-scrollPaper": {},
    ".MuiDialog-paperWidthSm": {
      overflow: "hidden",
      maxWidth: "none",
    },
    " .MuiDialog-paper ": {},
    ".MuiFormLabel-root": {
      color: "black",
    },
  },
})(() => null);

export default function ImportData(props) {
  const classes = styles();
  const { uploadCSV } = ImportDataAPI();
  const { state, dispatch } = useContext(Context);
  const history = useHistory();

  const { t, i18n } = useTranslation()
  const [exportData, setExportData] = useState([]);
  const [states, setstates] = useState({
    columns: [],
    currentYear: "",
    dialog: false,
    data: [],
    selectedFields: [],
    loading: false,
  });

  // For bread-crumbs
  useEffect(() => {
    dispatch({
      type: "SET_PATHNAME",
      payload: ["HOME", "ADMIN", "Import Data"],
    });
  }, []);

  const setStates = useCallback((newState) => {
    setstates((states) => ({ ...states, ...newState }));
  }, []);

  let selectedColumns = ImportDataHeader.map((header) => header.label);

  function handleChange(event) {
    selectedColumnFun();
    importCSV(event.target.files[0]);
  }

  function updateData(result) {
    var data = result.data;
    preparePayload(data);
  }

  function importCSV(csvFile) {
    Papa.parse(csvFile, {
      complete: updateData,
      header: true,
    });
  }

  function preparePayload(data) {
    const payload = [];
    let isError = false;
    data.forEach((value, i) => {
      let reason_code = value?.["Reason Code"]?.toLowerCase();
      if(isError && i==data?.length-1){
        toast.error((`*${t("Reason Code should be ACH or Premium or Rebate or Points Adjustment")
        }`), {
        ...toastCss,
        autoClose: 5000,
      },{ toastId: "import error" });
      return
      }
      
      if (
        JSON.stringify(selectedColumns) === JSON.stringify(Object.keys(value))
      ) {
        //---------condition for restricting records other than ACH, Premium, Rebate, Points Adjustment or Legacy Transfer        
        if (reason_code.trim().replace(/\s+/g, ' ')  != "ach" && reason_code.trim().replace(/\s+/g, ' ')  != "premium" && reason_code.trim().replace(/\s+/g, ' ')  != "rebate" && reason_code?.trim().replace(/\s+/g, ' ') != "points adjustment" && reason_code.trim().replace(/\s+/g, ' ')  != "legacy transfer" ) {
          isError = true;
          document.getElementById("demo").value = null;
         
  
          return;
        }
     
        //---------------------------------------------------------------------
        let achData = {};
        ImportDataHeader.forEach((header) => {
          achData[header.key] = value[header.label];
          if (header.key === "points") {
            achData[header.key] = parseInt(value[header.label]);
          }
        });
        payload.push(achData);
      }
    

    });

    if (payload.length === 0 && !isError) {
      toast.error(`*${t("Please import csv file in given order")
        }`, {
        ...toastCss,
        autoClose: 5000,
      });
      document.getElementById("demo").value = null;
    }
    setStates({ data: payload });
  }

  const handleUploadCSV = async () => {
    try {
      let emptyArray=states?.data?.map(e=> e.rule_description =="" ||e.transaction_type =="" || e.points==""||isNaN(e.points))

      let emptarraycheck =emptyArray.some(el => el === true) 
      

      if(emptarraycheck){
        toast.error((`*${t("Please make sure to fill in all the required fields.")
        }`), {
        ...toastCss,
        autoClose: 5000,
      },{ toastId: "import data error" });
      return;
    
      }
      let values = {
        data: states.data,
        importDate: moment().format("YYYY-MM-DD")
      };
      setStates({ loading: true });
      let res = await uploadCSV(values);
      setStates({ loading: false });
      if (res.type === "success" && res.valid) {
        setStates({ dialog: false });
        return history.push("/dashboard/import-status", {
          data: {
            
            successCount:res.successCount  // Adding successData
          },
          type: i18n.language == 'fr' ? res.french_message : res.message,
        });
      } else if (res.type === "success" && res.invalid) {
        let headers=[...ImportDataHeader,{

          label: "Reason",
          key: "reason",
},
        {
          label: "Status",
          key: "status",
        }
 ]
        return history.push("/dashboard/import-status", {
          
          obj: {
            data: {
              invalidData: res.invalidData,
              successData: res.successData,  // Adding successData
            },
            uploadedCount: res.uploadedCount,
            invalidCount: res.invalidCount,
            successCount: res.successCount,
            ImportDataHeader,
            headers
          },
        });
      }
    } catch (err) {
      setStates({ loading: false });
      console.log(err);
    }
  };

  function selectedColumnFun() {
    {
      setStates({ data: [] });
      let data = [];
      ImportDataHeader.map((header, i) => {
        if (selectedColumns?.includes(header.label)) {
          data = [...data, header.key];
          return;
        }
      });
      setStates({ selectedFields: data });
    }
  }

  const pointsFormat = (value) => {
    var nfObject = new Intl.NumberFormat("en-US");
    var points = nfObject.format(value);
    return points;
  };
  return (
    <React.Fragment>
      <GlobalCss />
      <div>
        <Grid container spacing={0}>
          <Grid
            item
            xs={12}
            style={{
              textAlign: "center",
              fontSize: 20,
              padding: 5,
              fontWeight: "bold",
            }}
          ></Grid>
          <Grid
            item
            xs={12}
            style={{ textAlign: "center", fontSize: 20, padding: 10 }}
          >
            {state?.userInfo?.loyalty_organization_name === 'Henry Schein Dental'?(
              <><span style={{ fontWeight: "bold" }}>
              {" "}
              {t('Import Data ACH/Rebate/Premium')}
            </span></>

            )
            :
          <><span style={{ fontWeight: "bold" }}>
          {" "}
          {t('Import Data')}
           <div>{t('Reason Code : ACH/Rebate/Premium/Legacy Transfer/Points Adjustment (Courtesy)')}</div>
        </span></>
          
          }
            
            {/* <span style={{ fontWeight: "bold" }}>
              {" "}
              {t('Import Data ACH/Rebate/Premium/')}
            </span> */}
          </Grid>
          <Grid
            item
            xs={12}
            style={{ textAlign: "right", fontSize: 18, padding: 10 }}
          >
            <span style={{ fontWeight: "bold" }}>{t('Import Date')} : </span>
            <span>{dateFormat(moment(), i18n.language)}</span>
          </Grid>

          <Grid
            item
            xs={6}
            style={{ textAlign: "left", fontSize: 12, padding: 10 }}
          > {state?.userInfo?.loyalty_organization_name === 'Henry Schein Dental'?
            <span style={{ fontWeight: "normal" }}>
              * {t('Please import csv file in below order')}
            </span>:
      
           
            <span style={{ fontWeight: "normal" }}>
              * {t('Please import csv file in below order and the "Points Adjustment" reason code will be classified as courtesy points in the Roll forward report')}
            </span>}
          </Grid>
          
          <Grid
            item
            xs={6}
            style={{ display: "flex", justifyContent: 'flex-end' }}
          >
            <button
              type='button'
              className={classes.exportBtn}
              onClick={async () => {
                // if (res) {
                document.getElementById('csv').click();
                // }
              }}
            >
              Download
            </button>
          </Grid>
          {states.data && states.data.length > 0 ? (
            <Grid
              item
              xs={6}
              style={{ textAlign: "right", fontSize: 14, padding: 10 }}
            >
              <span style={{ fontWeight: "normal" }}>
                {" "}
                {t('Total Count')} : {states.data.length}
              </span>
            </Grid>
          ) : (
            ""
          )}
        </Grid>
        {true ? (
          true ? (
            <TableContainer className={classes.tableContainer}>
              <Table
                className={classes.table}
                aria-labelledby="tableTitle"
                size={"medium"}
                aria-label="enhanced table"
              >
                <TableHead
                  style={{
                    background: "#EDEDED"
                  }}
                >
                  <TableRow>
                    {selectedColumns?.map((h, i) => (
                      <TableCell key={t(h)} className={classes.tableHeading}>
                        {t(h)}
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {states.data?.slice(0, 10)?.map((p, i) => (
                    <TableRow role="checkbox" tabIndex={-1} key={i}>
                      {states.selectedFields.map((s) => (
                        <TableCell
                          key={p?.[s]}
                          align="left"
                          className={classes.rowCell}
                        >
                          {s === "points" ? pointsFormat(p?.[s]) : p?.[s]}
                        </TableCell>
                      ))}
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          ) : (
            <NoData />
          )
        ) : (
          ""
        )}
      </div>
      <Grid
        item
        xs={12}
        style={{
          textAlign: "center",
          marginTop: 10,
          marginBottom: 10,
          marginLeft: 40,
        }}
      >
        <div onClick={() => {
          if (!state?.userInfo?.editAction) {
            toast.error(state.userInfo?.editAccess)
            return;
          }
          return;
        }}>
          <input
            id="demo"
            type="file"
            accept=".csv"
            placeholder={t("import csv")}
            onChange={(e) => {
              if (state?.userInfo?.editAction) {
                handleChange(e)
                return;
              }
              else {
                toast.error(state.userInfo?.editAccess)
                return;
              }
            }}
            disabled={!state?.userInfo?.editAction}
          />
        </div>
      </Grid>
      {<Loader Loading={states?.loading}></Loader>}
      {states.data && states.data.length > 0 && (
        <Grid container spacing={0}>
          <Grid item xs={12} style={{ padding: 20, textAlign: "center" }}>
            <Button
              className={
                states?.loading ? classes.uploadBtnDisabled : classes.uploadBtn
              }
              onClick={handleUploadCSV}
              disabled={states?.loading}
            >
              {t('Upload')}
            </Button>
            <Button
              className={classes.previewBtn}
              onClick={() => {
                setStates({
                  dialog: false,
                  data: [],
                });
                document.getElementById("demo").value = null;
              }}
            >
              {t('Cancel')}
            </Button>
          </Grid>
        </Grid>
      )}
      <CSVLink
        id='csv'
        data={exportData}
        headers={ImportDataHeader}
        filename={'importData' +
          ' ' +
          moment(new Date()).format('MM-DD-YYYY,h:mm A') +
          '.csv'
        }
        className={classes.CSVlink}
      />
      {/* <div>
        <ul>
          <li style ={{ fontWeight:'bold',fontSize :"20px"}}>* ACH</li>
          <li style ={{ fontWeight:'bold',fontSize :"20px"}}>* Rebate</li>
          <li style ={{ fontWeight:'bold',fontSize :"20px"}}>* Legacy Transfer</li>
          <li style ={{ fontWeight:'bold',fontSize :"20px"}}>* Premium</li>
        </ul>
      </div> */}
    </React.Fragment>
  );
}
